export interface AutoSaveTripPayload {
  recipe: unknown;
  headline: string;
  origin: 'auto';
  publishedTripId?: string;
  price?: number;
  selectedDate?: string;
}

// getRecipeForShareWidget (shareWidgetStoreLogic.ts) is the only source we
// have for a recipe here, but its output shape depends on the live
// shared-widget-clean-recipe toggle: `{ recipe: {...} }` when off, or the
// recipe fields directly when on. That toggle exists for the share widget's
// own needs, not ours, so rather than pushing this dependency further
// downstream (to creators-api, which expects the recipe fields directly
// either way), it's normalized right here where the JSON string is parsed.
interface WrappedShareWidgetRecipe {
  recipe: unknown;
}

function isWrappedShareWidgetRecipe(
  parsed: unknown
): parsed is WrappedShareWidgetRecipe {
  return parsed !== null && typeof parsed === 'object' && 'recipe' in parsed;
}

function unwrapShareWidgetRecipe(parsed: unknown): unknown {
  return isWrappedShareWidgetRecipe(parsed) ? parsed.recipe : parsed;
}

export function buildAutoSaveTripPayload(params: {
  recipe: string;
  price?: number;
  selectedDate?: string | null;
  publishedTripId?: string;
}): AutoSaveTripPayload {
  const payload: AutoSaveTripPayload = {
    recipe: unwrapShareWidgetRecipe(JSON.parse(params.recipe)),
    headline: '',
    origin: 'auto',
  };

  if (params.publishedTripId) {
    payload.publishedTripId = params.publishedTripId;
  }
  if (params.price) {
    payload.price = params.price;
  }
  if (params.selectedDate) {
    payload.selectedDate = params.selectedDate;
  }

  return payload;
}
